module.exports = __webpack_public_path__ + "media/src/assets/Images/openedArrow-efe10c0a218658b8f4439b1d353340d5.svg";